<template>
  <navbar :show-navbar="showNavbar">
    <div class="navbar-wrapper">
      <div class="navbar-toggle" :class="{toggled: $sidebar.showSidebar}">
        <navbar-toggle-button @click.native="toggleSidebar"></navbar-toggle-button>
      </div>
      <!-- Companies Switch -->
      <div v-if="account.role === 'admin' || account.role === 'reseller'" class="form-group pull-left mr-3">
        <el-select class="select-primary" v-model="companyID" placeholder="CompanyID" filterable>
          <el-option class="select-default" v-for="item in companies" :key="item.id" :label="item.id + ' ' + item.name" :value="item.id"> </el-option>
        </el-select>
      </div>
      <div v-if="account.role === 'admin'"  class="form-group pull-left mr-3">
        <n-button class="btn btn-sm btn-primary" @click.native="copyToken"> Copy Token </n-button>
      </div>
    </div>
    <ul class="p-0 m-0">
      <div style="width: 100%!important; padding-top: 5px;">
        <img style="width: 40px; height: 40px; border-radius: 30px;" :src="company.logo">
        <span class="ml-2">{{company.name}}</span>
      </div>
    </ul>
    <button @click="toggleNavbar" class="navbar-toggler pull-right" type="button" data-toggle="collapse"
            data-target="#navigation" aria-controls="navigation-index"
            aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button>
    <template slot="navbar-menu">
      <ul class="navbar-nav">

        <!-- Notifications -->
        <el-badge :value="notifications.filter(n => !n.seen).length" :hidden="notifications.filter(n => !n.seen).length === 0" :max="9" class="item">
          <drop-down tag="li" position="right" hideArrow class="nav-item notification-dropdown" icon="now-ui-icons ui-1_bell-53">
            <button v-for="notification in notifications.filter(n => !n.seen)" :key="notification.id" class="dropdown-item" @click="notificationSeen(notification)"> {{notification.description}} <i class="now-ui-icons ui-1_simple-remove"></i></button>
          </drop-down>
        </el-badge>

        <!-- Languages -->
        <drop-down tag="li" position="right" class="nav-item" :title="$ml.get(appLanguage.toLowerCase())" icon="now-ui-icons location_world">
          <button v-for="lang in $ml.list" class="dropdown-item" :key="lang"
                  @click="$ml.change(lang); setLanguage(lang)">
            <img style="max-width: 33px; margin-right: 7px;" :src="languageFlag(lang)" alt="">
            {{$ml.get(lang.toLowerCase())}}</button>
        </drop-down>

        <!-- Account -->
        <drop-down position="right" hideArrow class="nav-item" icon="now-ui-icons objects_key-25" :title="$ml.get('log_out')" @click.prevent.native="logout">
          <button class="dropdown-item">
            {{$ml.get('see_you_soon')}}
            <i class="now-ui-icons">👋</i>
          </button>
        </drop-down>
      </ul>
    </template>
  </navbar>
</template>
<script>
  import {RouteBreadCrumb, Navbar, NavbarToggleButton } from '../components';
  import {CollapseTransition} from 'vue2-transitions'
  import { mapGetters, mapActions, mapMutations } from 'vuex'
  import { Select, Option, Badge } from 'element-ui';
  import { EventBus } from "../store/event-bus";
  import Notification from '../services/Notification';
  import to from 'await-to-js';
  export default {
    components: {
      RouteBreadCrumb,
      Navbar,
      NavbarToggleButton,
      CollapseTransition,
      [Badge.name]: Badge,
      [Select.name]: Select,
      [Option.name]: Option,
    },
    data() {
      return {
        activeNotifications: false,
        showNavbar: false,
        companyID: 0
      }
    },
    mounted() {
      if ((parseInt(localStorage.getItem('CompanyId'))) && this.companyID === 0) {
        this.companyID = parseInt(localStorage.getItem('CompanyId'));
      }
    },
    methods: {
      ...mapActions(['setLanguage']),
      ...mapMutations(['setCompanyId']),
      copyToken() {
        this.copy(localStorage.getItem('token'));
      },
      async notificationSeen(notification) {
        notification.seen = true;
        let [err] = await to(Notification.seen(notification.id));
        if (err) this.errorSnack(err);
      },
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown() {
        this.activeNotifications = false
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      toggleNavbar() {
        this.showNavbar = !this.showNavbar;
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      logout () {
        this.$store.dispatch('logout')
      }
    },
    computed: {
      ...mapGetters(['companies', 'notifications', 'aps']),
      routeName() {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      }
    },
    watch: {
      companyID(nv, ov) {
        this.setCompanyId(nv);
        EventBus.$emit('companyChanged');
        if (ov !== 0) location.reload();
        this.$forceUpdate()
      }
    }
  }

</script>
<style>
 .notification-dropdown .dropdown-menu {
   max-height: 250px!important;
   overflow-y: scroll;
 }

 .el-badge__content {
   top: 5px!important;
   right: 25px!important;
 }
</style>
